import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 17.5425L23.6797 19.0005L20.4551 20.4565L19 23.6792L17.5439 20.4556L14.3203 19.0005L17.5439 17.5435L19 14.3208L20.4551 17.5425ZM22.415 6.49951L8.29395 20.6206C7.73133 21.1833 6.96757 21.4995 6.17188 21.4995H1.5L1.50098 16.8276C1.50111 16.0322 1.81647 15.269 2.37891 14.7065L16.501 0.585449L22.415 6.49951ZM6.07715 2.92139L8.24414 3.99951L6.07715 5.07764L5 7.24365L3.92188 5.07764L1.75586 3.99951L3.92188 2.92139L5 0.756348L6.07715 2.92139ZM3.5 19.4995H6.17188C6.43706 19.4995 6.69138 19.394 6.87891 19.2065L8.58594 17.4985L5.50098 14.4136L3.79395 16.1206C3.60651 16.308 3.50109 16.5626 3.50098 16.8276L3.5 19.4995Z"}}]};

const AiEditFilled = Vue.extend<IconProps>({
  name: 'AiEditFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-edit-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiEditFilled;
